import React, { useState, useEffect } from 'react';
import contentfulConfig from '../../config/contentfulConfig';
import { createClient } from 'contentful';
import { Link } from 'react-router-dom';
import Loading from "../../components/Loading";

const client = createClient({
  space: contentfulConfig.space,
  accessToken: contentfulConfig.accessToken,
});

function ProjectsData({ max_items }) {
  const [entries, setEntries] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Track loading state


  useEffect(() => {
    // Fetch data from Contentful
    client
      .getEntries({
        content_type: 'projects',
        // You can add additional filters or options here
      })
      .then((response) => {
        setEntries(response.items);
        setIsLoading(false); // Set loading state to false when data is fetched
      })
      .catch(        
        console.error
      );
  }, []);
  const limitedEntries = max_items ? entries.slice(0, max_items) : entries;

  return (
    <>
    {isLoading ? ( // Check loading state
        <Loading />
      ) : (
        limitedEntries.map((entry) => (
        <Link className='item ' to={'/projects/' + entry.sys.id} key={entry.sys.id}>
          <div className='image-wrapper'><img className='featured-image' src={entry.fields.featuredImage.fields.file.url} alt={entry.fields.title} /></div>
          <div className='description-box'>
            <div className='title'>{entry.fields.title}</div>
            <div className='sub-title'>{entry.fields.subTitle}</div>
          </div>
        </Link>
      )))
    }
    </>
  );
}

export default ProjectsData;
